import { render, staticRenderFns } from "./VendorCategoryComponent.vue?vue&type=template&id=5ece42a5&"
import script from "./VendorCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./VendorCategoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports